export class ReportingApi {
    constructor(httpRequest) {
        this.httpRequest = httpRequest;
    }
    /**
     * @returns any
     * @throws ApiError
     */
    getAvgRecruiterResponseTime({ startTime, endTime, groupId, userId, }) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/reporting/recruiter-response-time',
            query: {
                'startTime': startTime,
                'endTime': endTime,
                'groupId': groupId,
                'userId': userId,
            },
        });
    }
    /**
     * @returns any
     * @throws ApiError
     */
    getAvgRecruiterFirstResponseTime({ startTime, endTime, groupId, userId, }) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/reporting/recruiter-first-response-time',
            query: {
                'startTime': startTime,
                'endTime': endTime,
                'groupId': groupId,
                'userId': userId,
            },
        });
    }
    /**
     * @returns number
     * @throws ApiError
     */
    getResponseRate({ startTime, endTime, groupId, userId, }) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/reporting/response-rate',
            query: {
                'startTime': startTime,
                'endTime': endTime,
                'groupId': groupId,
                'userId': userId,
            },
        });
    }
    /**
     * @returns number
     * @throws ApiError
     */
    getContactEnrichmentRate({ startTime, endTime, groupId, userId, }) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/reporting/contact-enrichment-rate',
            query: {
                'startTime': startTime,
                'endTime': endTime,
                'groupId': groupId,
                'userId': userId,
            },
        });
    }
    /**
     * @returns number
     * @throws ApiError
     */
    getUserAdoptionRate({ startTime, endTime, groupId, userId, }) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/reporting/user-adoption-rate',
            query: {
                'startTime': startTime,
                'endTime': endTime,
                'groupId': groupId,
                'userId': userId,
            },
        });
    }
    /**
     * @returns number
     * @throws ApiError
     */
    getEngagementRate({ startTime, endTime, groupId, userId, }) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/reporting/engagement-rate',
            query: {
                'startTime': startTime,
                'endTime': endTime,
                'groupId': groupId,
                'userId': userId,
            },
        });
    }
    /**
     * @returns any
     * @throws ApiError
     */
    getAvgConversationLength({ startTime, endTime, groupId, userId, }) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/reporting/avg-conversation-length',
            query: {
                'startTime': startTime,
                'endTime': endTime,
                'groupId': groupId,
                'userId': userId,
            },
        });
    }
    /**
     * @returns ContactFoundInfoRateDto
     * @throws ApiError
     */
    getContactFoundInfoRate({ startTime, endTime, groupId, userId, }) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/reporting/contact-found-info-rate',
            query: {
                'startTime': startTime,
                'endTime': endTime,
                'groupId': groupId,
                'userId': userId,
            },
        });
    }
    /**
     * @returns EmailOutreachStatsDto
     * @throws ApiError
     */
    getEmailOutreachStats({ startTime, endTime, groupId, userId, }) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/reporting/email-outreach-stats',
            query: {
                'startTime': startTime,
                'endTime': endTime,
                'groupId': groupId,
                'userId': userId,
            },
        });
    }
    /**
     * Count entities.
     * @returns any
     * @throws ApiError
     */
    count({ startTime, endTime, entity, groupId, userId, }) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/reporting',
            query: {
                'startTime': startTime,
                'endTime': endTime,
                'groupId': groupId,
                'userId': userId,
                'entity': entity,
            },
        });
    }
}
